function createSourcesDragGhost(label) {
    if (typeof document === 'undefined') {
        return null;
    }

    const ghost = document.createElement('div');
    ghost.textContent = label || 'Dragging item';
    ghost.style.position = 'fixed';
    ghost.style.top = '-9999px';
    ghost.style.left = '-9999px';
    ghost.style.padding = '6px 10px';
    ghost.style.borderRadius = '8px';
    ghost.style.border = '1px solid rgba(0, 0, 0, 0.16)';
    ghost.style.background = '#ffffff';
    ghost.style.color = 'rgba(0, 0, 0, 0.87)';
    ghost.style.fontSize = '12px';
    ghost.style.fontWeight = '600';
    ghost.style.lineHeight = '16px';
    ghost.style.maxWidth = '260px';
    ghost.style.overflow = 'hidden';
    ghost.style.whiteSpace = 'nowrap';
    ghost.style.textOverflow = 'ellipsis';
    ghost.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.14)';
    ghost.style.pointerEvents = 'none';
    ghost.style.zIndex = '2147483647';
    document.body.appendChild(ghost);
    return ghost;
}

export function applySourcesDragGhost(dataTransfer, label) {
    if (!dataTransfer?.setDragImage) {
        return;
    }

    const ghost = createSourcesDragGhost(label);
    if (!ghost) {
        return;
    }

    dataTransfer.setDragImage(ghost, 10, 10);
    window.setTimeout(() => {
        ghost.remove();
    }, 0);
}
